import {Component, OnInit} from "@angular/core";

@Component({
  selector: 'app-check-your-email',
  templateUrl: './check-your-email.component.html',
  styleUrls: ['./check-your-email.component.scss'],
})
export class CheckYourEmailComponent implements OnInit {
  showPassword: boolean = false;
  constructor() {
  }

  ngOnInit() {
  }
}
